import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo3_Rodrigo } from '../../../../../utils/EN/Modals/directors';

const ModalVideoRodrigo3 = () => {
  return (
    <>
      <ModalVideo
        id="rodrigo-video-3"
        dataText={TextVideo3_Rodrigo}
        videoSrc="https://player.vimeo.com/video/1099461127?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_RODRIGO_3"
      />
    </>
  );
};

export default ModalVideoRodrigo3;
